/* 🤖 this file was generated by svg-to-ts */
export const matIconCurrencyFranc: {
  name: 'currency-franc';
  data: string;
} = {
  name: 'currency-franc',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z"/></svg>`
};
